import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { BookingProvider } from "./context/BookingContext";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Membership from "./pages/Membership";
import Financing from "./pages/Financing";
import Rewards from "./pages/Rewards";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import GiftCards from "./pages/GiftCards";
import FirstVisit from "./pages/FirstVisit";
import Gallery from "./pages/Gallery";
import Shop from "./pages/Shop";
import ShopProduct from "./pages/ShopProduct";
import Quiz from "./pages/Quiz";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CheckIn from "./pages/CheckIn";
import Admin from "./pages/Admin";
import AppPrivacy from "./pages/AppPrivacy";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import SetPassword from "./pages/SetPassword";
import ToxDeposit from "./pages/ToxDeposit";
import ToxDepositThankYou from "./pages/ToxDepositThankYou";
import NewClientDeposit from "./pages/NewClientDeposit";
import GfeRedirect from "./pages/GfeRedirect";
import { AdminRoute } from "./components/AdminRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BookingProvider>
            <Toaster position="top-center" />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/financing" element={<Financing />} />
                <Route path="/rewards" element={<Rewards />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/team" element={<Team />} />
                <Route path="/gift-cards" element={<GiftCards />} />
                <Route path="/first-visit" element={<FirstVisit />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:slug" element={<ShopProduct />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/app-privacy" element={<AppPrivacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/tox-deposit" element={<ToxDeposit />} />
                <Route path="/tox-deposit/thank-you" element={<ToxDepositThankYou />} />
                <Route path="/new-client-deposit" element={<NewClientDeposit />} />
                <Route path="/gfe" element={<GfeRedirect />} />
                <Route path="/checkin" element={<CheckIn />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <Admin />
                    </AdminRoute>
                  }
                />
              </Route>
            </Routes>
          </BookingProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
